// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"styles_closeIcon__5XUuv"};